import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, Navbar, NavItem } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';

import * as AuthAction from '../../actions/Auth';

import { ADMIN, BACK_OFFICE } from '../../constants/accountType';

import Localization from '../../config/localization';

import Colorbar from '../Colorbar';

import EllipseSvg from '../Svg/ellipse';
import HouseSvg from '../Svg/house';

import './NavBar.scss';
import { AidType, Routes } from '../../constants/routes';
import { generatePath } from 'react-router';
import { isAccountType } from '../../lib/user';
import { isAuthenticated } from '../../lib/authenticated';

type IProps = NavBar.IProps & ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class CustomNavBar extends React.Component<IProps, NavBar.IState> {
  state = { mouseIn: '' };

  renderLogOutButton = () => {
    if (!this.props.Auth || !this.props.Auth.token) {
      return null;
    }

    return (
      <NavItem className="mx-2 my-auto h-100">
        <NavLink className="eon-title eon-darkgrey" to={Routes.HomePage} onClick={this._logOut}>
          {Localization.navBarLogout}
        </NavLink>
      </NavItem>
    );
  };

  _isAccountType = (accountTypeName: string) => isAccountType(accountTypeName, this.props.Auth);

  render() {
    return (
      <div className="navbar-c">
        <Colorbar />
        <Container className="navbar-container position-relative">
          <div className="topbar-bottombar" />
          <div className="mx-4 flex-nowrap d-flex">
            <Navbar expand={true}>
              <Nav className="ml-auto text-nowrap" navbar>
                <NavItem className="mx-2 my-auto h-100">
                  <NavLink to={Routes.HomePage} className="d-flex">
                    <HouseSvg className="m-auto" />
                  </NavLink>
                </NavItem>
                {isAuthenticated(this.props.Auth) && <NavItem className="mx-2 my-auto h-100">
                  <EllipseSvg />
                </NavItem>}
                {isAuthenticated(this.props.Auth) && (<Dropdown
                  nav
                  inNavbar
                  isOpen={this.state.mouseIn === 'natural-gas'}
                  onMouseLeave={this._onMouseLeave}
                  onMouseEnter={this._onMouseEnter}
                  toggle={this._undefined}
                  data-key="natural-gas"
                >
                  <DropdownToggle className="eon-title eon-darkgrey" nav>
                    {Localization.navBarNaturalGas}
                  </DropdownToggle>
                  <DropdownMenu className="eon-expended-navbar">
                    <DropdownItem
                      className="eon-title eon-darkgrey c-pointer-no-color"
                      name={generatePath(Routes.AidsSearch, { aidType: AidType.NaturalGas })}
                      onClick={this._dropDownClick}>
                      {Localization.navBarNaturalGasAid}
                    </DropdownItem>
                    <DropdownItem
                      className="eon-title eon-darkgrey c-pointer-no-color"
                      name={generatePath(Routes.AdditionSearch, { aidType: AidType.NaturalGas })}
                      onClick={this._dropDownClick}
                    >
                      {Localization.navBarNaturalGasAddition}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>)}
                {isAuthenticated(this.props.Auth) && (<Dropdown
                  nav
                  inNavbar
                  isOpen={this.state.mouseIn === 'electric-energy'}
                  onMouseLeave={this._onMouseLeave}
                  onMouseEnter={this._onMouseEnter}
                  toggle={this._undefined}
                  data-key="electric-energy"
                >
                  <DropdownToggle className="eon-title eon-darkgrey" nav>
                    {Localization.navBarElectricEnergy}
                  </DropdownToggle>
                  <DropdownMenu className="eon-expended-navbar">
                    <DropdownItem
                      className="eon-title eon-darkgrey c-pointer-no-color"
                      name={generatePath(Routes.AidsSearch, { aidType: AidType.ElectricEnergy })}
                      onClick={this._dropDownClick}
                    >
                      {Localization.navBarElectricEnergyAid}
                    </DropdownItem>
                    <DropdownItem
                      className="eon-title eon-darkgrey c-pointer-no-color"
                      name={generatePath(Routes.AdditionSearch, { aidType: AidType.ElectricEnergy })}
                      onClick={this._dropDownClick}
                    >
                      {Localization.navBarElectricEnergyAddition}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>)}
                {isAuthenticated(this.props.Auth) && (<Dropdown
                  nav
                  inNavbar
                  isOpen={this.state.mouseIn === 'report'}
                  onMouseLeave={this._onMouseLeave}
                  onMouseEnter={this._onMouseEnter}
                  toggle={this._undefined}
                  data-key="report"
                >
                  <DropdownToggle className="eon-title eon-darkgrey" nav>
                    {Localization.navBarReport}
                  </DropdownToggle>
                  <DropdownMenu className="eon-expended-navbar">
                    {this._isAccountType(ADMIN) && (
                      <DropdownItem className="eon-title eon-darkgrey c-pointer-no-color" name={Routes.PartnerExport}
                                    onClick={this._dropDownClick}>
                        {Localization.navBarPartnerExport}
                      </DropdownItem>
                    )}

                    <DropdownItem className="eon-title eon-darkgrey c-pointer-no-color" name={Routes.Report}
                                  onClick={this._dropDownClick}>
                      {Localization.navBarReport}
                    </DropdownItem>
                    <DropdownItem
                      className="eon-title eon-darkgrey c-pointer-no-color"
                      name={Routes.PaymentReports}
                      onClick={this._dropDownClick}
                    >
                      {Localization.navBarPaymentReport}
                    </DropdownItem>
                    <DropdownItem
                      className="eon-title eon-darkgrey c-pointer-no-color"
                      name={Routes.PaymentReportsAddition}
                      onClick={this._dropDownClick}
                    >
                      {Localization.navBarPaymentReportAdditions}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>)}
                {isAuthenticated(this.props.Auth) && <NavItem className="mx-2 my-auto h-100">
                  <EllipseSvg />
                </NavItem>}
                {isAuthenticated(this.props.Auth) && <Dropdown
                  nav
                  inNavbar
                  isOpen={this.state.mouseIn === 'settings'}
                  onMouseLeave={this._onMouseLeave}
                  onMouseEnter={this._onMouseEnter}
                  toggle={this._undefined}
                  data-key="settings"
                >
                  <DropdownToggle className="eon-title eon-darkgrey" nav>
                    {Localization.navBarSettings}
                  </DropdownToggle>
                  <DropdownMenu className="eon-expended-navbar">
                    {this._isAccountType(ADMIN) && (
                      <DropdownItem className="eon-title eon-darkgrey c-pointer-no-color" name={Routes.BlockMonth}
                                    onClick={this._dropDownClick}>
                        {Localization.navBarSettingsBlockMonth}
                      </DropdownItem>
                    )}

                    {this._isAccountType(ADMIN) && (
                      <DropdownItem className="eon-title eon-darkgrey c-pointer-no-color" name={Routes.BillAids}
                                    onClick={this._dropDownClick}>
                        {Localization.navBarBillAids}
                      </DropdownItem>
                    )}
                    {this._isAccountType(ADMIN) && (
                      <DropdownItem className="eon-title eon-darkgrey c-pointer-no-color" name={Routes.BillAdditions}
                                    onClick={this._dropDownClick}>
                        {Localization.navBarBillAdditions}
                      </DropdownItem>
                    )}

                    <DropdownItem className="eon-title eon-darkgrey c-pointer-no-color" name={Routes.Account}
                                  onClick={this._dropDownClick}>
                      {Localization.navBarMyAccount}
                    </DropdownItem>

                    {(this._isAccountType(ADMIN) || this._isAccountType(BACK_OFFICE)) && (
                      <DropdownItem className="eon-title eon-darkgrey c-pointer-no-color" name={Routes.Search}
                                    onClick={this._dropDownClick}>
                        {Localization.navBarBackOfficeSearch}
                      </DropdownItem>
                    )}

                    <DropdownItem className="eon-title eon-darkgrey c-pointer-no-color" name={Routes.History}
                                  onClick={this._dropDownClick}>
                      {Localization.navBarBilledAidsHistory}
                    </DropdownItem>

                  </DropdownMenu>
                </Dropdown>}
                {this.renderLogOutButton()}
              </Nav>
            </Navbar>
            <div className="ml-auto my-auto h-100">
              <div className="eon-logo small" />
            </div>
          </div>
        </Container>
      </div>
    )
      ;
  }

  _onMouseEnter = (event: any) => {
    this.setState({ mouseIn: event.currentTarget.dataset.key });
  };

  _onMouseLeave = () => {
    this.setState({ mouseIn: '' });
  };

  _logOut = () => {
    this.props.ClearAuth();
    return this.props.history.push(Routes.Login);
  };

  _undefined = () => {
    return undefined;
  };

  _dropDownClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const target = event.currentTarget || event.target || {};

    this.setState({ mouseIn: '' });

    return this.props.history.push(target.name);
  };
}

const mapStateToProps = (state: General.Store) => ({ Auth: state.Auth });

const mapDispatchToProps = (dispatch: Dispatch) => ({ ...bindActionCreators({ ...AuthAction }, dispatch) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CustomNavBar));
